import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import {
  getNoteList,
  createNoteItem,
  deleteNoteItem,
  updateNoteItem,
} from 'middleware/note/actions';
import {
  getGroupDeviceData,
  setNotificationRead,
  getGroupDeviceDataOnTabChange,
} from 'middleware/data/actions';
import { getGroupList } from 'middleware/group/actions';
import { updateFamilyItem, listAllFamily } from 'middleware/family/actions';
import { getSettingsList } from 'middleware/settings/actions';
import { getNotificationList } from 'middleware/notification/actions';
import { updateGroupListStore } from 'store/groupList/actions';
import { removeNotificationItemSuccess } from 'store/notification/actions';
import { editNoteItem, cancelEditNoteItem } from 'store/noteList/actions';
import { clearData } from 'store/actions';
import Home from './home';

const mapStateToProps = (state) => {
  const {
    groups, marginRight, activeKey, currentFamilies, isLoading, tabChangeRefresh,
    currentFamiliesObj,
  } = state.groupListReducer;
  const { notifications, families } = state.notificationListReducer;
  const { notes, isEditing, editID } = state.noteListReducer;
  const { isLoggedIn, displayName, role } = state.accountReducer;
  return {
    tabChangeRefresh,
    isLoggedIn,
    displayName,
    role,
    groups,
    activeKey,
    currentFamilies,
    isLoading,
    marginRight,
    notifications,
    families,
    notes,
    isEditing,
    editID,
    currentFamiliesObj,
  };
};

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      getNoteList,
      createNoteItem,
      getGroupList,
      getGroupDeviceData,
      updateGroupListStore,
      getGroupDeviceDataOnTabChange,
      setNotificationRead,
      deleteNoteItem,
      editNoteItem,
      cancelEditNoteItem,
      updateNoteItem,
      updateFamilyItem,
      listAllFamily,
      removeNotificationItemSuccess,
      getSettingsList,
      clearData,
      getNotificationList,
    },
    dispatch,
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(Home);
